// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { commonEnv } from "./environment.common";

const clientId = "e1fe2595-78d6-4211-a55a-83bde943750c";
const tenantName = "iaptstb2c";
const tenantId = "0c917ae9-0dbd-405c-9819-3f1d5d6c6eb6";
const scopes = [clientId];
// const scopes = [
//   `api://${clientId}/.default`,
//   "https://iapdevb2c.onmicrosoft.com/admin/read",
// ];
const appUrl = "https://intl-agent-tst.senecapolytechnic.ca";
const instrumentationKey = "8083af93-afd1-4616-8cd6-6bc76b3fb6b9";
const agentPolicy = "B2C_1A_SIGNIN_WITH_ROLES_ONLYLOCAL-FORCERESET"; // Your sign-in policy
//const agentPolicy = "B2C_1A_signin_with_roles"; // Your sign-in policy
const applicantPolicy = commonEnv.applicantSignInPolicy;
const azureInstance = commonEnv.azureInstance;
const resetPasswordPolicy = "B2C_1_resetpassword";
export class BuildEnvironment {
  constructor() {}

  public static GetEnvironmentUrl(): string {
    return environment.apiConfig.apiUrl;
  }
}

export const environment = {
  production: false,
  showTestButton: true,
  applicantPolicy: commonEnv.applicantSignInPolicy,
  azureInstance: commonEnv.azureInstance,
  googleTagManagerId: commonEnv.googleTagManagerId,
  resetPasswordPolicy: "B2C_1_resetpassword",
  tenant: "iaptstb2c",
  msalConfig: {
    auth: {
      clientId: clientId,
      authority: `https://${tenantName}.b2clogin.com/tfp/${tenantName}.onmicrosoft.com/${agentPolicy}`,
      redirectUri: `http://localhost:4200/`,
      knownAuthorities: [`${tenantName}.b2clogin.com`], // array of URIs that are known to be valid,
      // validateAuthority: true,
      // navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true,
    },
  },
  apiConfig: {
    scopes: scopes,
    uri: `${appUrl}`,

    apiUrl:
      "https://seneapi-apims-tst.azure-api.net/agentportal/public/controllers/api",
    // apiUrl: "http://localhost:4000/public/controllers/api",
  },
  appInsights: {
    instrumentationKey: instrumentationKey,
    scopes: [clientId],
  },

  msalAgentConfigs: {
    clientID: clientId,
    authority: `${azureInstance}/${tenantId}/${agentPolicy}`,
    consentScopes: scopes,
    redirectUri: `${appUrl}`,
    cacheLocation: "localStorage",
    //Phase 1 - Policy settings - starts 2
    //cacheLocation: "sessionStorage",
    //Phase 1 - Policy settings - starts 2
    // Phase 2 - Policy settings - starts 4
    //cacheLocation: "localStorage",
    // Phase 2 - Policy settings - ends 4
    navigateToLoginRequestUrl: false,
    postLogoutRedirectUri: `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${appUrl}/logout`,
    storeAuthStateInCookie: true,
    validateAuthority: false,
  },

  // apiSubscriptionKeyName: "AgentPortal-Apim-Subscription-Key",
  // apiSubscriptionKey: "8eb008c3d6e5437ba5cbdb4b3396df25",
  apiSubscriptionKeyName: "AGNTPRTL-Apim-Subscription-Key",
  apiSubscriptionKey: "a73d2cb541b04764995335319ec85e90",
  apiSubscriptionEnabled: true,
  agentSignInPolicy: agentPolicy,
  applicantSignInPolicy: applicantPolicy,
  iwaAppUrl: "https://iap-tst.senecapolytechnic.ca/agent",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
